/**
 * Gemeinde entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from './BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';

export class BusinessType extends BaseModel {
    public id: number | null = null;
    public type: string | null = null;
    public bezeichnung: string | null = null;
    public ech_value: string | null = null;


    mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    getClassName(): string {
        return 'BusinessType';
    }

}

export class BusinessTypeCollection extends BaseCollection<BusinessType> {
    protected modelCls = BusinessType;

    public getModelClassName(): string {
        return 'BusinessType';
    }
}
